import { render, staticRenderFns } from "./selectReasonAction.vue?vue&type=template&id=77f81980&scoped=true"
import script from "./selectReasonAction.vue?vue&type=script&lang=js"
export * from "./selectReasonAction.vue?vue&type=script&lang=js"
import style0 from "./selectReasonAction.vue?vue&type=style&index=0&id=77f81980&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77f81980",
  null
  
)

export default component.exports